var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"carousel",staticClass:"eco-carousel"},[_c('Slider',_vm._b({staticClass:"eco-carousel-slider eco-carousel__slider"},'Slider',{
      itemsLength: _vm.itemsLength,
      activeSlideIndex: _vm.activeSlideIndex,
      itemsPerSlide: _vm.itemsPerSlide,
      itemMarginRightInPx: _vm.itemMarginRightInPx,
      withArrows: _vm.withArrows,
      slidingAnimationTimeInMs: _vm.slidingAnimationTimeInMs,
      minDraggingDisplacementInPx: _vm.minDraggingDisplacementInPx,
      navigationButtonIcon: _vm.navigationButtonIcon
    },false),[_vm._t("default")],2),(_vm.withPagination)?_c('Pagination',_vm._b({staticClass:"eco-carousel-pagination eco-carousel__pagination"},'Pagination',{ activeSlideIndex: _vm.activeSlideIndex, slidesLength: _vm.slidesLength },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }